import { render, staticRenderFns } from "./control.vue?vue&type=template&id=c2fad268&scoped=true&"
import script from "./control.vue?vue&type=script&lang=js&"
export * from "./control.vue?vue&type=script&lang=js&"
import style0 from "./control.vue?vue&type=style&index=0&id=c2fad268&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fad268",
  null
  
)

export default component.exports